import SocialMediaGroup from 'components/SocialMediaGroup';
import { ContainerSocialMediaGroup } from 'components/SocialMediaGroup/SocialMediaGroup.styles';
import React from 'react';
import { getAppSettings } from 'utils/privateLabel';

const RenderSocialIcons = (): React.ReactElement<any> => (
  <ContainerSocialMediaGroup>
    <SocialMediaGroup icons={getAppSettings().socialMedia} />
  </ContainerSocialMediaGroup>
);

export default RenderSocialIcons;
